import { CitationsJWT, User } from '@chegg-wt/core/types/auth'
import { evalParsedJwt, parseJwt } from '@chegg-wt/core/utils/jwt'
import { Config } from '../config'
import { trackWithoutThrow } from './errors'
import { getCookie, Cookies } from './cookies'

export const selectIdTokenFromCookie = () => getCookie(Cookies.IdToken)

const idTokensMatch = (jwt: CitationsJWT): boolean => {
  const idTokenFromCookie = selectIdTokenFromCookie()
  return jwt.cheggTokens?.id_token === idTokenFromCookie
}

// TODO: remove once SA removes writing cookies on log out
// The id_token cookie being undefined and the jwt id_token being null indicates a guest user
const isLoggedOutFromTokenState = (jwt: CitationsJWT): boolean => {
  return (
    !selectIdTokenFromCookie() &&
    jwt.cheggTokens?.id_token !== null &&
    !idTokensMatch(jwt)
  )
}

const siteMatches = (jwt: CitationsJWT): boolean => {
  return jwt.site === Config.tokenSiteCode
}

export function tokenIsCurrent(jwt: string) {
  return evalParsedJwt(
    jwt,
    (parsedJwt) => siteMatches(parsedJwt) && idTokensMatch(parsedJwt),
    false
  )
}

// TODO: remove once SA removes writing cookies on log out
export function hasLoggedOutExternally(jwt: string) {
  return evalParsedJwt(jwt, isLoggedOutFromTokenState, false)
}

export const mapJwtEmailToUser = (userResponse: User): User => {
  const { jwt } = userResponse

  try {
    const decodedJwt: CitationsJWT = parseJwt(jwt)
    return {
      ...userResponse,
      user: {
        ...userResponse.user,
        email: decodedJwt.email,
      },
    }
  } catch (e) {
    trackWithoutThrow(e)

    return {
      ...userResponse,
      user: {
        ...userResponse.user,
        email: '',
      },
    }
  }
}
